/* Toko Milobi storefront measurement (Measurement Map rows 3, 4, 5, 6, 7, 8, 16, 21, 23).
   - GA4 delivery: the page gtag that the Google & YouTube app already loads (same client_id + session as its
     page_view / add_to_cart / purchase, so the journey stays joined). gtag only exists after analytics consent,
     so nothing is sent without consent. Events go to the GA4 property only (send_to), never to Ads.
   - Every event is also published as a Shopify customer event (Shopify.analytics.publish, name 'tm_' + event)
     so a custom pixel can pick them up later without theme changes.
   - Does NOT send page_view, view_item, add_to_cart, view_cart, begin_checkout or purchase: those are owned
     by the Google & YouTube app. view_item_list is only sent for rails/recommendation blocks, never for the
     main collection grid (the app sends that one). */
(function(){
  'use strict';
  var GA4 = 'G-8EF3JRYC9R';
  var LOW = 3500, FREE = 5500; // cents: EUR 35 (shipping price drops), EUR 55 (free shipping)
  var ctx = window.tmCtx || {};
  var q = [], waited = 0;

  function base(){
    var c = {page_type: ctx.page_type || '', region: ctx.region || ''};
    var el = document.querySelector('.tmx-rh--country .tmx-rh__chip.is-active');
    c.country = el ? chipCountry(el) : '';
    if (c.country && c.page_type === 'region') c.page_type = 'country';
    return c;
  }
  function flush(){
    if (typeof window.gtag !== 'function') return false;
    while (q.length){ var e = q.shift(); window.gtag('event', e[0], e[1]); }
    return true;
  }
  function wait(){
    if (flush() || waited > 30) return;
    waited++; setTimeout(wait, 1000);
  }
  function send(name, params){
    var p = {}, b = base();
    for (var k0 in b){ if (b[k0]) p[k0] = b[k0]; }
    for (var k in params){ if (params[k] !== undefined && params[k] !== null && params[k] !== '') p[k] = params[k]; }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('tm_' + name, p); } catch(e){}
    var g = {}; for (var j in p) g[j] = p[j];
    g.send_to = GA4;
    q.push([name, g]);
    if (!flush() && waited === 0) wait();
    if (window.tmDebug) console.log('[tm]', name, g);
  }
  window.tmTrack = send;

  // Where did the shopper find a product? Remember list (and recipe) per product for the PDP add.
  function remember(pid, data){
    try { var m = JSON.parse(sessionStorage.getItem('tmSrc') || '{}'); m[pid] = data; sessionStorage.setItem('tmSrc', JSON.stringify(m)); } catch(e){}
  }
  function recall(pid){
    try { return (JSON.parse(sessionStorage.getItem('tmSrc') || '{}'))[pid] || null; } catch(e){ return null; }
  }
  function cardItem(card, index){
    var it = {item_id: card.getAttribute('data-tmx-product'), item_name: txt(card.querySelector('.tmx-card__title, .tmx-rrow__name')) || undefined,
      item_brand: txt(card.querySelector('.tmx-card__vendor')) || undefined, item_list_name: card.getAttribute('data-tmx-list') || undefined};
    var price = Number(card.getAttribute('data-price') || 0) || money(txt(card.querySelector('.tmx-card__price')));
    if (price) it.price = price / 100;
    if (index !== undefined) it.index = index;
    return it;
  }
  function listCards(card){
    var list = card.getAttribute('data-tmx-list');
    var scope = card.parentNode;
    return Array.prototype.filter.call(scope.querySelectorAll('[data-tmx-list]'), function(c){ return c.getAttribute('data-tmx-list') === list; });
  }
  var GRID_LISTS = {'region-grid': 1, 'grid': 1};
  function txt(el){ return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function slug(t){ return t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function money(t){ var m = (t || '').match(/(\d+[.,]\d{2})/); return m ? Math.round(parseFloat(m[1].replace(',', '.')) * 100) : 0; }
  // Promotion id for a seasonal spotlight: name + year from its date label, e.g. 'diwali-2026'
  function spotId(el){
    var y = (txt(el.querySelector('.tmx-spot__date')).match(/20\d\d/) || [String(new Date().getFullYear())])[0];
    return slug(txt(el.querySelector('.tmx-spot__name'))) + '-' + y;
  }
  function chipCountry(el){ var c = el.cloneNode(true); var sp = c.querySelector('span'); if (sp) sp.remove(); return txt(c); }

  // ---- Clicks ---------------------------------------------------------------
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;

    // Row 3: homepage region tiles
    if (a.classList.contains('tmx-region')){
      var tiles = Array.prototype.slice.call(document.querySelectorAll('.tmx-region'));
      var h = (a.pathname.match(/\/collections\/([^\/?#]+)/) || [])[1] || '';
      send('select_region', {selected_region: h, region_label: txt(a.querySelector('.tmx-region__name')), index: tiles.indexOf(a) + 1, link_url: a.href});
      return;
    }

    // Rows 4 + 5: hero buttons and seasonal spotlights
    if (a.classList.contains('tmx-spot')){
      var spots = Array.prototype.slice.call(document.querySelectorAll('.tmx-spot'));
      send('select_promotion', {promotion_id: spotId(a), promotion_name: txt(a.querySelector('.tmx-spot__name')), creative_slot: 'season-' + (spots.indexOf(a) + 1), link_url: a.href});
      return;
    }
    if (a.matches('.tmx-hero .tmx-btn')){
      var btns = Array.prototype.slice.call(document.querySelectorAll('.tmx-hero .tmx-btn'));
      send('select_promotion', {promotion_id: 'hero-cta-' + (btns.indexOf(a) + 1), promotion_name: txt(a), creative_slot: 'hero', link_url: a.href});
      return;
    }

    // Row 8: country chips on region pages
    if (a.classList.contains('tmx-rh__chip') && (ctx.page_type === 'region') && a.search.indexOf('filter.') > -1){
      send('select_country', {selected_country: chipCountry(a), products_shown: Number(txt(a.querySelector('span'))) || undefined});
      return;
    }

    // Rows 6, 16, 21, 22: product cards and recipe rows in any list (select_item is not sent by the Google app)
    var card = a.closest('[data-tmx-product]');
    if (card){
      var cards = listCards(card), idx = cards.indexOf(card);
      var item = cardItem(card, idx >= 0 ? idx : undefined);
      var extra = {item_list_name: item.item_list_name, items: [item]};
      if (card.closest('[data-recipe-shop]')) extra.recipe_id = recipeId();
      send('select_item', extra);
      remember(item.item_id, {list: item.item_list_name, recipe: extra.recipe_id || ''});
      return;
    }
    // Recipe insert card inside the region grid / recipe cards on the PDP
    var ins = a.closest('.tmx-insert[data-tmx-list], .tmx-recipe[data-tmx-list]');
    if (ins){ send('select_promotion', {promotion_id: 'recipe:' + (a.pathname.split('/').pop()), promotion_name: ins.getAttribute('data-tmx-list'), creative_slot: ins.getAttribute('data-tmx-list')}); }
  }, true);

  // ---- Impressions: rails and recommendation blocks (rows 5, 6, 16) -----------
  var seen = {};
  function observeLists(){
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var t = en.target;
        if (t.classList.contains('tmx-spot')){
          var pid = spotId(t);
          if (seen['p:' + pid]) return; seen['p:' + pid] = 1;
          var all = Array.prototype.slice.call(document.querySelectorAll('.tmx-spot'));
          send('view_promotion', {promotion_id: pid, promotion_name: txt(t.querySelector('.tmx-spot__name')), creative_slot: 'season-' + (all.indexOf(t) + 1)});
          return;
        }
        var list = t.getAttribute('data-tmx-list');
        if (!list || GRID_LISTS[list] || seen['l:' + list]) return;
        seen['l:' + list] = 1;
        var cards = listCards(t).slice(0, 12);
        send('view_item_list', {item_list_name: list, items: cards.map(function(c, i){ return cardItem(c, i); })});
      });
    }, {threshold: 0.5});
    function scan(){
      document.querySelectorAll('.tmx-spot:not([data-tm-obs]), .tmx-card[data-tmx-list]:not([data-tm-obs]), .tmx-rrow[data-tmx-list]:not([data-tm-obs])').forEach(function(el){
        el.setAttribute('data-tm-obs', '1');
        var l = el.getAttribute('data-tmx-list');
        if (l && (GRID_LISTS[l] || seen['l:' + l])) return;
        // one observer per list: the first card is enough
        if (l && document.querySelector('[data-tm-obs][data-tmx-list="' + l.replace(/"/g, '') + '"][data-tm-first]')) return;
        if (l) el.setAttribute('data-tm-first', '1');
        io.observe(el);
      });
    }
    scan();
    // recommendation blocks load after the page (native recommendations endpoint)
    if ('MutationObserver' in window){ var mo = new MutationObserver(function(){ clearTimeout(mo.t); mo.t = setTimeout(scan, 300); }); mo.observe(document.body, {childList: true, subtree: true}); }
  }

  // ---- Add to cart source (row 7 + PDP + row 21) ------------------------------
  // The add_to_cart ecommerce event itself is sent by the Google & YouTube app; this event adds WHERE it came from.
  document.addEventListener('tm:quick-add', function(e){
    var d = e.detail || {}, it = d.card ? cardItem(d.card) : {};
    send('add_to_cart_source', {cart_add_source: 'quick_add', item_list_name: it.item_list_name, item_id: it.item_id, item_name: it.item_name, variant_id: d.variant_id,
      quantity: 1, value: it.price, currency: 'EUR'});
  });
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f || !f.matches || !f.matches('form.product-form')) return;
    var pid = f.getAttribute('data-product-id');
    var vid = (f.querySelector('[name=id]') || {}).value;
    var qty = Number((f.querySelector('[name=quantity]') || {}).value || 1);
    var src = recall(pid) || {};
    send('add_to_cart_source', {cart_add_source: 'pdp', item_list_name: src.list || 'direct', recipe_id: src.recipe || undefined, item_id: pid, variant_id: vid, quantity: qty, currency: 'EUR'});
  }, true);
  function recipeId(){ return (location.pathname.split('/').pop() || '').split('?')[0]; }
  var pendingRecipe = null;
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-recipe-add]');
    if (!b) return;
    var root = b.closest('[data-recipe-shop]'); if (!root) return;
    var items = [], offered = 0, allOn = true, value = 0;
    root.querySelectorAll('[data-recipe-item]').forEach(function(r){
      var c = r.querySelector('[data-recipe-select]'); if (!c || c.disabled) return;
      offered++;
      if (!c.checked){ allOn = false; return; }
      var qn = Math.max(1, parseInt((r.querySelector('[data-recipe-quantity]') || {}).value, 10) || 1), pr = Number(r.getAttribute('data-price') || 0);
      value += qn * pr;
      items.push({item_id: r.getAttribute('data-tmx-product'), item_name: txt(r.querySelector('.tmx-rrow__name')), item_variant: String(c.getAttribute('data-variant-id')), quantity: qn, price: pr / 100});
    });
    if (!items.length) return;
    pendingRecipe = {at: Date.now(), p: {recipe_id: recipeId(), add_all: allOn ? 'yes' : 'no', products_selected: items.length, products_offered: offered, value: value / 100, currency: 'EUR', items: items}};
  }, true);
  function recipeAdded(){
    if (!pendingRecipe || Date.now() - pendingRecipe.at > 8000) { pendingRecipe = null; return; }
    var p = pendingRecipe.p; pendingRecipe = null;
    send('recipe_add_to_cart', p);
    // Keep the recipe on the order (hidden cart attribute) so recipe-generated orders and revenue show in Shopify.
    try {
      var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(r + 'cart.js').then(function(x){ return x.json(); }).then(function(cart){
        var cur = (cart.attributes && cart.attributes._tm_recipes) || '';
        var list = cur ? cur.split(',') : [];
        if (list.indexOf(p.recipe_id) === -1) list.push(p.recipe_id);
        return fetch(r + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {_tm_recipes: list.slice(-5).join(',')}})});
      }).catch(function(){});
    } catch(err){}
  }

  // ---- Cart value vs EUR 35 / EUR 55 thresholds (row 23) ----------------------
  var last = '';
  function cartStatus(trigger){
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(r + 'cart.js', {headers: {'Accept': 'application/json'}}).then(function(x){ return x.json(); }).then(function(c){
      var key = c.total_price + ':' + c.item_count;
      if (key === last) return; last = key;
      if (!c.item_count && trigger !== 'cart_page') return;
      var v = c.total_price;
      send('cart_status', {trigger: trigger, value: v / 100, currency: 'EUR', cart_items: c.item_count,
        shipping_tier: v >= FREE ? 'free_55' : (v >= LOW ? 'reduced_35' : 'below_35'),
        to_reduced_shipping: v < LOW ? (LOW - v) / 100 : 0, to_free_shipping: v < FREE ? (FREE - v) / 100 : 0,
        recipe_cart: (c.attributes && c.attributes._tm_recipes) ? 'yes' : 'no'});
    }).catch(function(){});
  }
  if (ctx.page_type === 'cart') cartStatus('cart_page');
  if ('PerformanceObserver' in window){
    try {
      var t;
      new PerformanceObserver(function(list){
        list.getEntries().forEach(function(en){
          if (/\/cart\/add(\.js)?(\?|$)/.test(en.name) && en.responseStatus !== 422) recipeAdded();
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(en.name)){ clearTimeout(t); t = setTimeout(function(){ cartStatus('cart_change'); }, 900); }
        });
      }).observe({type: 'resource', buffered: false});
    } catch(e){}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeLists); else observeLists();
})();
